import PropTypes from "prop-types";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { START_DATE } from "react-dates/constants";
import { useI18N } from "../../common/common";
import { useApartmentSearchAvailability } from "../../hooks";

const ApartmentCategoryAvailabilityCalendarProvider = ({children}) => {
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarText, setSnackbarText] = useState("");
    const [snackbarButton, setSnackbarButton] = useState(undefined);
    const [snackbarType, setSnackbarType] = useState("info");
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [focus, setFocus] = useState(START_DATE);

    const {i18n} = useI18N();
    const {error} = useApartmentSearchAvailability();

    const handleOpenSnackbar = (text, button, type = "info") => {
        setSnackbarText(text);
        setSnackbarButton(button);
        setSnackbarType(type);
        setShowSnackbar(true);
    };

    const handleCloseSnackbar = () => {
        setSnackbarText("");
        setSnackbarButton(undefined);
        setSnackbarType("info");
        setShowSnackbar(false);
    };

    const handleSnackbarButtonClick = useCallback(() => {
        window.open(snackbarButton?.url, "_blank");
        handleCloseSnackbar();
    }, []);

    useEffect(() => {
        if (error) {
            handleOpenSnackbar(i18n("common.label.error_message"));
        }
    }, [error]);

    useEffect(() => {
        if (showSnackbar) {
            const t = setTimeout(() => {
                handleCloseSnackbar();
            }, 5000);

            return () => clearTimeout(t);
        }
    }, [showSnackbar]);

    return (
        <ApartmentCategoryAvailabilityCalendarContext.Provider value={{
            showSnackbar,
            snackbarText,
            snackbarButton,
            snackbarType,
            dateFrom,
            setDateFrom,
            dateTo,
            setDateTo,
            focus,
            setFocus,
            handleSnackbarButtonClick,
            handleOpenSnackbar
        }}
        >
            {children}
        </ApartmentCategoryAvailabilityCalendarContext.Provider>
    );
};

ApartmentCategoryAvailabilityCalendarProvider.propTypes = {
    children: PropTypes.any
};

export const ApartmentCategoryAvailabilityCalendarContext = createContext();
export default ApartmentCategoryAvailabilityCalendarProvider;
